import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-[#1C2024] text-white py-10">
            <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                    <h3 className="text-lg font-medium mb-4">HAKKIMIZDA</h3>
                    <ul className="space-y-2">
                        <li><a href="/biz-kimiz" className="text-gray-400 hover:text-white">Biz Kimiz</a></li>
                        <li><a href="/politika" className="text-gray-400 hover:text-white">Kurum Politikamız</a></li>
                        <li><a href="/materyaller" className="text-gray-400 hover:text-white">Görsel Materyaller</a></li>
                        <li><a href="/iletisim" className="text-gray-400 hover:text-white">Bize Ulaşın</a></li>
                        <li><a href="/entertainment" className="text-gray-400 hover:text-white">Live Nation Entertainment</a></li>
                        <li><a href="/hikaye" className="text-gray-400 hover:text-white">Biletinizin Hikayesi</a></li>
                    </ul>
                </div>

                <div>
                    <h3 className="text-lg font-medium mb-4">BİZİ TAKİP EDİN</h3>
                    <div className="flex space-x-4 mb-6">
                        <a href="/instagram" className="text-gray-400 hover:text-white"><i className="fab fa-instagram text-xl"></i></a>
                        <a href="/facebook" className="text-gray-400 hover:text-white"><i className="fab fa-facebook text-xl"></i></a>
                        <a href="/twitter" className="text-gray-400 hover:text-white"><i className="fab fa-twitter text-xl"></i></a>
                        <a href="/blog" className="text-gray-400 hover:text-white"><i className="fas fa-blog text-xl"></i></a>
                        <a href="/youtube" className="text-gray-400 hover:text-white"><i className="fab fa-youtube text-xl"></i></a>
                        <a href="/linkedin" className="text-gray-400 hover:text-white"><i className="fab fa-linkedin text-xl"></i></a>
                        <a href="/spotify" className="text-gray-400 hover:text-white"><i className="fab fa-spotify text-xl"></i></a>
                        <a href="/tiktok" className="text-gray-400 hover:text-white"><i className="fab fa-tiktok text-xl"></i></a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;